function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 306,
  height: 140,
  fill: "white",
  fillOpacity: 0.9
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M131.61 83.4143C131.61 83.8029 131.933 84.1255 132.323 84.1255H145.156C145.55 84.1255 145.869 83.8029 145.869 83.4143V48.3203H131.61V83.4143Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M160.132 83.4143C160.132 83.8029 160.45 84.1255 160.844 84.1255H173.678C174.071 84.1255 174.39 83.8029 174.39 83.4143V48.3203H160.132V83.4143Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M103.803 48.3203C103.407 48.3203 103.088 48.6424 103.088 49.0393V83.4143C103.088 83.8029 103.407 84.1255 103.803 84.1255H116.634C117.028 84.1255 117.346 83.8029 117.346 83.4143V48.3203H103.803Z",
  fill: "#B07120"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M202.912 49.0393C202.912 48.6424 202.593 48.3203 202.199 48.3203H188.653V83.4143C188.653 83.8029 188.972 84.1255 189.365 84.1255H202.199C202.593 84.1255 202.912 83.8029 202.912 83.4143V49.0393Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M130.898 34H118.061C117.67 34 117.346 34.3231 117.346 34.7156V48.3202H131.61V34.7156C131.61 34.3231 131.287 34 130.898 34Z",
  fill: "#B07120"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M159.419 34H146.585C146.192 34 145.869 34.3231 145.869 34.7156V48.3202H160.132V34.7156C160.132 34.3231 159.808 34 159.419 34Z",
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M187.94 34H175.102C174.713 34 174.389 34.3231 174.389 34.7156V48.3202H188.653V34.7156C188.653 34.3231 188.33 34 187.94 34Z",
  fill: "black"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M166.801 111.423C166.801 110.465 166.801 103.357 166.801 103.337C166.781 103.337 166.013 103.337 165.993 103.337C165.993 103.356 165.993 112.402 165.993 112.402C170.061 111.981 170.601 108.707 170.869 107.273C170.845 107.273 170.154 107.273 170.137 107.273C169.68 109.942 168.575 110.907 166.801 111.423Z",
  fill: "black"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M180.424 103.134L180.069 103.379C180.446 103.791 180.811 104.291 181.077 104.77L181.631 104.392C181.221 103.835 180.845 103.468 180.424 103.134Z",
  fill: "black"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M181.509 102.656L181.144 102.923C181.487 103.29 181.808 103.691 182.108 104.192L182.673 103.802C182.362 103.424 181.919 102.979 181.509 102.656Z",
  fill: "black"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M208.087 103.226L207.733 103.47C208.109 103.882 208.475 104.383 208.741 104.861L209.294 104.483C208.885 103.927 208.508 103.559 208.087 103.226Z",
  fill: "black"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M209.173 102.747L208.807 103.014C209.151 103.382 209.472 103.782 209.771 104.282L210.336 103.893C210.026 103.515 209.583 103.07 209.173 102.747Z",
  fill: "black"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M154.17 108.405C154.19 108.405 160.566 108.405 160.586 108.405C160.586 108.385 160.586 107.556 160.586 107.536C160.566 107.536 154.19 107.536 154.17 107.536C154.17 107.556 154.17 108.385 154.17 108.405Z",
  fill: "black"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M179.522 103.757C179.501 103.757 173.677 103.757 173.656 103.757C173.656 103.777 173.656 104.489 173.656 104.51C173.677 104.51 179.501 104.51 179.522 104.51C179.522 104.489 179.522 103.777 179.522 103.757Z",
  fill: "black"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M172.623 107.363C172.643 107.363 176.791 107.363 176.791 107.363V107.796C176.766 109.051 176.414 110.145 175.85 110.722C175.076 111.528 173.818 111.798 173.206 111.927C173.206 111.944 173.206 112.64 173.206 112.664C174.745 112.404 175.756 111.967 176.387 111.289C177.18 110.42 177.568 109.316 177.609 107.816C177.609 107.815 177.634 107.363 177.634 107.363C177.634 107.363 181.085 107.363 181.105 107.363C181.105 107.343 181.105 106.609 181.105 106.589C181.085 106.589 172.643 106.589 172.623 106.589C172.623 106.609 172.623 107.343 172.623 107.363Z",
  fill: "black"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M193.882 105.783C193.027 105.218 191.929 104.707 190.835 104.367C190.828 104.382 190.518 105.015 190.507 105.036C191.418 105.336 192.663 105.961 193.432 106.564C193.444 106.545 193.872 105.8 193.882 105.783Z",
  fill: "black"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M152.051 104.844C152.03 104.844 148.327 104.844 148.327 104.844C148.327 104.844 148.327 103.197 148.327 103.177C148.307 103.177 147.529 103.177 147.508 103.177C147.508 103.197 147.508 104.844 147.508 104.844C147.508 104.844 143.806 104.844 143.786 104.844C143.786 104.864 143.786 105.598 143.786 105.618C143.806 105.618 147.508 105.618 147.508 105.618C147.508 105.618 147.508 112.644 147.508 112.664C147.529 112.664 148.307 112.664 148.327 112.664C148.327 112.644 148.327 105.618 148.327 105.618C148.327 105.618 152.03 105.618 152.051 105.618C152.051 105.598 152.051 104.864 152.051 104.844Z",
  fill: "black"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M144.257 110.063C143.929 110.719 143.567 111.098 143.406 111.265C143.422 111.279 144.067 111.854 144.082 111.866C144.761 111.078 145.495 109.895 145.798 107.116C145.776 107.116 145.019 107.116 145.001 107.116C144.903 108.281 144.652 109.273 144.257 110.063Z",
  fill: "black"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M150.834 107.072C150.816 107.072 150.06 107.072 150.038 107.072C150.34 109.851 151.074 111.034 151.754 111.823C151.769 111.809 152.414 111.235 152.429 111.221C152.268 111.055 151.907 110.676 151.579 110.019C151.183 109.229 150.932 108.238 150.834 107.072Z",
  fill: "black"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M118.705 103.183H113.013V103.933H115.12V106.063H112.52V106.812H115.12C115.12 107.298 115.118 108.093 114.977 108.942H112.932V109.691H114.815C114.523 110.767 113.956 111.811 112.845 112.326V112.988C114.536 112.502 115.294 111.093 115.63 109.691H118.705V106.812H119.292V106.063H118.705V103.183ZM117.933 108.942H115.773C115.874 108.256 115.892 107.615 115.892 107.134V106.812H117.933V108.942ZM117.933 106.063H115.892V103.933H117.933V106.063Z",
  fill: "black"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M139.915 103.183H132.77V106.689C132.77 107.105 132.78 107.621 132.762 108.173H131.737V108.923H132.718C132.597 110.292 132.218 111.709 131.061 112.306V113C132.849 112.586 133.365 110.595 133.505 108.923H139.144V113H139.915V108.923H140.949V108.173H139.915V103.183H139.915ZM139.144 108.173H133.546C133.564 107.548 133.542 107.025 133.542 106.734V103.933H139.144V108.173Z",
  fill: "black"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M101.029 111.825V109.305H102.246V108.556H101.029V106.969H102.437V106.22H101.029V104.428H102.246V103.679H101.029V102.359H100.257V103.679H98.7572V104.428H100.257V106.22H98.7572V106.969H100.257V111.312C99.8123 110.841 99.5851 110.223 99.5851 109.263V108.68H98.8136V109.95C98.8136 110.998 98.6606 111.715 98.1948 112.221V112.976C98.8711 112.666 99.2205 112.008 99.4011 111.343C99.5252 111.567 99.6746 111.767 99.8493 111.942C100.705 112.798 101.906 112.794 102.357 112.792L107.921 112.792V112.024L102.355 112.024C102.077 112.025 101.548 112.026 101.029 111.825Z",
  fill: "black"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M111.644 102.36C111.497 103.257 111.284 105.48 109.423 106.789V107.515C109.745 107.384 110.334 107.131 110.926 106.471V113H111.698V105.317C112.06 104.597 112.37 103.639 112.552 102.359L111.644 102.36Z",
  fill: "black"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M136.762 107.059L137.451 106.5C136.916 105.994 136.145 105.338 135.575 105.022L135.226 105.352C135.843 105.889 136.29 106.436 136.762 107.059Z",
  fill: "black"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M87 112.156C87.1608 112.156 96.6165 112.156 96.7776 112.156C96.7776 112.005 96.7776 111.533 96.7776 111.381C96.6165 111.381 87.1608 111.381 87 111.381C87 111.533 87 112.005 87 112.156Z",
  fill: "black"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M95.7892 103.507C95.629 103.507 88.1479 103.507 87.9878 103.507C87.9878 103.658 87.9878 104.129 87.9878 104.282C88.1479 104.282 95.629 104.282 95.7892 104.282C95.7892 104.129 95.7892 103.658 95.7892 103.507Z",
  fill: "black"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M95.3237 107.993C95.3237 107.841 95.3237 107.37 95.3237 107.218C95.1646 107.218 88.6132 107.218 88.4539 107.218C88.4539 107.37 88.4539 107.841 88.4539 107.993C88.6132 107.993 95.1646 107.993 95.3237 107.993Z",
  fill: "black"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M129.52 106.64C129.52 106.64 129.52 103.228 129.52 103.183H127.83V102.35H127.059V103.183H126.124V103.829H127.059C127.063 104.274 127.097 105.076 126.945 105.89C126.657 105.728 126.372 105.554 126.124 105.382V106.035C126.289 106.19 126.52 106.358 126.785 106.525C126.582 107.137 126.236 107.702 125.649 108.061V108.715C126.572 108.385 127.105 107.684 127.412 106.891C127.731 107.064 128.059 107.226 128.355 107.361V106.576C128.153 106.496 127.894 106.38 127.613 106.242C127.816 105.401 127.83 104.543 127.83 103.962V103.829H128.749V106.458C128.749 108.271 129.487 108.606 130.397 108.783C130.397 108.657 130.397 108.221 130.397 108.147C129.913 107.907 129.52 107.819 129.52 106.64Z",
  fill: "black"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M120.968 105.791C120.968 105.881 120.968 106.194 120.968 106.296C121.777 106.288 122.626 105.987 122.706 105.107H123.851C123.931 105.987 124.78 106.288 125.589 106.296C125.589 106.194 125.589 105.881 125.589 105.791C124.896 105.705 124.583 105.578 124.536 105.107H125.692V104.461H123.665V103.829H125.307V103.183H123.665V102.35H122.893V103.183H121.251V103.829H122.893V104.461H120.865V105.107H122.022C121.974 105.578 121.662 105.705 120.968 105.791Z",
  fill: "black"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M124.898 109.329V108.885H124.126V109.329H121.123V110.079H124.112C123.989 111.225 123.077 112.034 120.916 112.323V113C123.326 112.803 124.795 111.82 124.893 110.079H128.749V110.946C128.749 111.826 128.407 112.293 127.781 112.337C127.781 112.428 127.781 112.888 127.781 113C128.796 112.979 129.52 112.573 129.52 110.765L129.521 109.329H129.52H124.898Z",
  fill: "black"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M121.123 107.943V108.62C122.655 108.576 123.861 108.544 125.161 108.182V107.605C124.634 107.697 124.132 107.764 123.665 107.813V107.225H124.9V106.579H123.665V106.097H122.893V106.579H121.658V107.225H122.893V107.882C122.17 107.934 121.563 107.943 121.123 107.943Z",
  fill: "black"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M107.745 103.32C107.335 102.763 107.141 102.577 106.72 102.243L106.366 102.488C106.737 102.894 106.921 103.211 107.181 103.679H105.875V102.359H105.104V103.679H103.166V109.83C102.973 109.871 102.775 109.906 102.567 109.94V110.785C103.228 110.56 104.054 110.325 104.635 109.967V109.34C104.392 109.455 104.162 109.546 103.938 109.622V104.429H105.104V106C105.104 106.683 105.101 108.302 105.758 109.672C105.404 110.124 104.962 110.549 104.412 110.95V111.659C104.889 111.391 105.53 111.023 106.139 110.323C106.549 110.901 107.121 111.385 107.921 111.659V110.967C107.332 110.66 106.912 110.209 106.612 109.692C107.17 108.833 107.649 107.607 107.875 105.81L107.124 105.811C107.003 106.971 106.767 107.996 106.26 108.914C105.824 107.66 105.875 106.271 105.875 105.63V104.429H107.926V103.679H107.219L107.745 103.32Z",
  fill: "black"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M182.117 109.96V110.639C183.292 110.33 184.469 109.729 185.527 108.969C185.527 110.139 185.527 112.648 185.527 112.664C185.546 112.664 186.232 112.664 186.252 112.664C186.252 112.646 186.252 109.161 186.252 108.407C187.265 107.562 188.125 106.584 188.702 105.61H187.836C186.999 106.979 184.73 109.04 182.117 109.96Z",
  fill: "black"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M190.48 111.777C190.48 111.909 190.48 112.521 190.48 112.664C195.77 112.12 197.768 109.555 199.016 105.109C198.867 105.109 198.271 105.109 198.199 105.109C196.932 110.102 193.846 111.529 190.48 111.777Z",
  fill: "black"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M204.248 103.345C204.075 103.345 203.461 103.345 203.361 103.345C203.176 103.962 202.207 106.258 200.131 107.46C200.131 107.513 200.131 107.988 200.131 108.148C201.426 107.619 202.39 106.643 203.066 105.677H207.168C206.136 110.107 203.285 111.532 200.676 111.895V112.664C202.79 112.29 207.002 111.548 208.147 104.902H203.554C203.907 104.275 204.135 103.71 204.248 103.345Z",
  fill: "black"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M163.201 106.252C163.201 107.175 163.135 110.81 161.435 111.937V112.664C163.744 111.849 164.029 108.124 164.029 106.461V103.655H163.201V106.252Z",
  fill: "black"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M215.913 108.56C216.774 107.355 217.518 105.862 217.955 104.044H211.208V104.84H216.878C215.66 108.735 212.635 111.195 210.703 111.903V112.664C211.685 112.378 213.733 111.293 215.465 109.149C217.177 110.482 217.987 112.394 218.037 112.514C218.05 112.514 218.97 112.514 219 112.514C218.023 110.221 216.397 108.912 215.913 108.56Z",
  fill: "black"
});

var _ref40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_b",
  x: -4,
  y: -4,
  width: 314,
  height: 148,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})));

function SvgLogoMtks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 140,
    viewBox: "0 0 306 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMtks);
export default __webpack_public_path__ + "static/media/logo_mtks.35b24bd7.svg";
export { ForwardRef as ReactComponent };